/*global
AUDITO_API_URL
ORGANIZATION
ORGANIZATION_SLUG
ORGANIZATION_GRAPHQL_ID
STRIPE_PUBLIC_KEY
STRIPE_DEFAULT_PLAN
USER
SENTRY_CLIENT_DSN
SENTRY_CLIENT_ENV */
/*eslint no-undef: "error"*/
const apiUrl = typeof AUDITO_API_URL !== 'undefined' ? AUDITO_API_URL : null
const organizationId = typeof ORGANIZATION !== 'undefined' ? ORGANIZATION : null
const organizationGraphQLId =
  typeof ORGANIZATION_GRAPHQL_ID !== 'undefined' ? ORGANIZATION_GRAPHQL_ID : null
const organizationSlug =
  typeof ORGANIZATION_SLUG !== 'undefined' ? ORGANIZATION_SLUG : null
const user = typeof USER !== 'undefined' ? USER : null
const maxFileSize = 25 // in mb
const stripePublicKey =
  typeof STRIPE_PUBLIC_KEY !== 'undefined' ? STRIPE_PUBLIC_KEY : null
const stripeDefaultPlan =
  typeof STRIPE_DEFAULT_PLAN !== 'undefined' ? STRIPE_DEFAULT_PLAN : null
const sentryClientDsn =
  typeof SENTRY_CLIENT_DSN !== 'undefined' ? SENTRY_CLIENT_DSN : null // in mb
const sentryClientEnv =
  typeof SENTRY_CLIENT_ENV !== 'undefined' ? SENTRY_CLIENT_ENV : null // in mb

export {
  apiUrl,
  organizationGraphQLId,
  organizationId,
  organizationSlug,
  user,
  maxFileSize,
  stripePublicKey,
  stripeDefaultPlan,
  sentryClientDsn,
  sentryClientEnv,
}
